import React from 'react';
import HeaderSample from '../Header/Header';
import NavigationSample from '../Sidebar/Sidebar';
import MainArea from '../MainArea/MainArea';

interface MainStructureProps {
  children: React.ReactNode;
}

/**
 * MainStructure - Layout wrapper component
 * Provides consistent page layout with header, sidebar, and main content area
 *
 * @param children - Main page content to render in the content area
 */
const MainStructure: React.FC<MainStructureProps> = ({ children }) => {
  return (
    <div className="main-structure">
      <div className="header-demo-wrapper">
        <HeaderSample />
      </div>
      <div className="ap-navigation-demo-wrapper">
        <NavigationSample />
      </div>
      <MainArea>
        {children}
      </MainArea>
    </div>
  );
};

export default MainStructure;
